import { Box, BoxProps, ColorOptions, Icon, Text } from '@jfs/ui-new'
import { convertHexToRGBA } from '@jfs/ui-new/src/utils/utils'
import * as React from 'react'
import { FC, ReactElement } from 'react'
import ReactDOM from 'react-dom'
import { Modal as RNModal, Platform, SafeAreaView, View } from 'react-native'
import { styles } from './styles'

export const ModalTypes = {
  Bottom: 'Bottom',
  Centered: 'Centered',
  CenteredWrap: 'CenteredWrap',
  TopMenu: 'TopMenu',
  Right: 'Right',
  BottomTop: 'BottomTop',
  CenteredWrapBottom: 'CenteredWrapBottom',
  BottomTopFull: 'BottomTopFull',
  Bottom_Flex_Grow: 'Bottom_Flex_Grow',
}

export const ModalHeaderTypes = {
  Default: 'Default',
  White_Bg: 'White_Bg',
}

interface ModalProps {
  ID?: string
  show?: boolean
  title?: string
  headerType?: keyof typeof ModalHeaderTypes
  type?: keyof typeof ModalTypes
  scrollHorizontal?: boolean
  isFullWidth?: boolean
  onClose?: () => void
  onDismiss?: () => void
  children?: ReactElement | ((showDialog: (show: boolean) => void) => ReactElement)
  isFromDropDown?: boolean
  containerTopPadding?: any
  theme?: any
  testID?: string
  parent?: ReactElement
}
const Modal: FC<ModalProps> = ({
  type = 'Centered',
  show = false,
  children,
  onDismiss,
  title,
  containerTopPadding,
  isFromDropDown = false,
  theme,
  testID,
}: ModalProps) => {
  const modalStyle = styles(theme)
  const container = modalStyle[type].contentContainer
  const innerContainer = modalStyle[type].innerContainer(isFromDropDown)
  const background = modalStyle[type].background
  if (containerTopPadding) {
    container.paddingTop = containerTopPadding
  }

  const childComp = (
    <>
      <View style={container} pointerEvents={'box-none'}>
        <SafeAreaView style={innerContainer}>
          {!!title && <ModalHeader title={title} onDismiss={onDismiss} center={type === 'Centered'} theme={theme} />}
          {children}
        </SafeAreaView>
      </View>
      <View {...background} onPress={onDismiss} underlayColor={modalStyle.underlayColor}>
        <View />
      </View>
    </>
  )

  if (!show) {
    return null
  }

  const Modal = Platform.OS === 'web' ? WebModal : RNModal
  return (
    <Modal testID={testID} animationType="fade" transparent visible={show} onDismiss={onDismiss}>
      {childComp}
    </Modal>
  )
}

interface WebProps {
  children?: ReactElement | ((showDialog: (show: boolean) => void) => ReactElement)
  visible?: boolean
  onDismiss?: () => void
}
const WebModal = (props: WebProps) => {
  const { visible = false, children } = props

  if (!visible) {
    return null
  }

  const webModal = () => {
    return (
      <Box testID={'Modal'} {...modalStyle.modal}>
        {children}
      </Box>
    )
  }

  const renderPortal = (): React.ReactPortal => {
    const rootContainer: any = document.getElementById('approot')
    return ReactDOM.createPortal(webModal(), rootContainer || document.body)
  }

  return <Box>{renderPortal()}</Box>
}

const ModalHeader = ({ title = '', onDismiss = () => {}, center = false, theme, type = 'Default' }: any) => {
  const modalHeaderStyle = styles(theme)
  const titleStyle = modalHeaderStyle[type].headerTitle
  const headerStyle = modalHeaderStyle[type].containerHeader
  return (
    <Box {...headerStyle}>
      <Text {...titleStyle}>{title}</Text>
      {!center && (
        <Box
          onPress={onDismiss}
          testID="close-modal"
          underlayColor={theme ? (theme?.headingText as ColorOptions) : 'GREY_1_SEPARATOR'}
          {...modalHeaderStyle.containerButton}>
          <Icon
            id={'CLOSE'}
            size={16}
            color={theme ? (convertHexToRGBA(theme?.headingText, 50) as ColorOptions) : undefined}
          />
        </Box>
      )}
    </Box>
  )
}

const modalStyle = {
  modal: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, 0.73)' as ColorOptions,
  } as BoxProps,
}

export { Modal }
